const HERO_IMAGE =
  'https://res.cloudinary.com/dybjy1gw3/image/upload/v1786295804/tournament-photos/6a78b5de027df102e9cd7696/team/e20d49d1-ebc6-4d62-b31e-6800b04cb1e8.jpg';

const TOURNAMENT_URL =
  'https://www.dailysportslife.com/soccer/public/tournament/4c6547a9fa654372a7fc4df1ed4585c8';

export const OLD_MONKS_LITTLE_SOCCER_TOURNAMENT_SHARE_TOKEN = '4c6547a9fa654372a7fc4df1ed4585c8';
export const OLD_MONKS_LITTLE_SOCCER_RECAP_SLUG = 'old-monks-little-soccer-internal-2026-recap';

/** Old Monks — Little Soccer Internal 2026 tournament recap (Aug 4–9) */
export const OLD_MONKS_LITTLE_SOCCER_RECAP_POST = {
  id: 'featured-old-monks-little-soccer-recap-2026',
  slug: OLD_MONKS_LITTLE_SOCCER_RECAP_SLUG,
  clubId: '6a78b48d027df102e9cd7695',
  title: 'Old Monks at Little Soccer Internal: Road to the Final & Runner-Up Finish',
  excerpt:
    'Old Monks battled through the group stage and a semi-final rematch with Desi Tigers before falling 1–2 to Football Addicts in the final. Full scores, goal scorers, and squad photos from the Westerville tournament.',
  publishedAt: '2026-08-10T01:45:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'Old Monks',
  blogCategory: 'sports-events',
  featured: true,
  component: 'TournamentRecapBlogArticle',
  tournamentShareToken: OLD_MONKS_LITTLE_SOCCER_TOURNAMENT_SHARE_TOKEN,
  theme: 'club',
  photoSections: {
    teamPhotos: {
      eyebrow: 'Little Soccer Internal 2026',
      title: 'The Old Monks squad',
      intro:
        'Photos from the tournament week in Westerville — the team that reached the final. Tap any photo to enlarge.',
      altPrefix: 'Old Monks at Little Soccer Internal',
    },
    squad: {
      eyebrow: 'Meet the team',
      title: 'Old Monks roster',
      intro:
        'The players who wore the kit across group play, the semi-final, and the championship match — with tournament goals and assists where they contributed. Tap a player photo to enlarge.',
    },
    awards: {
      eyebrow: 'Tournament honors',
      title: 'Individual awards',
      intro: 'Standout performers recognized from the Little Soccer Internal tournament.',
    },
  },
  relatedPostsTitle: 'More club coverage',
  relatedPosts: [
    {
      slug: 'soccer-team-game-day-checklist',
      title: 'Soccer Team Game Day Checklist',
      blurb: 'match-day prep for tournament weekends.',
    },
    {
      slug: 'open-soccer-fields-powell-dublin-lewis-center-delaware-ohio',
      title: 'Ohio Open Soccer Fields Guide',
      blurb: 'where to train between tournament rounds.',
    },
  ],
  referenceLinks: [
    {
      label: 'Full Little Soccer Internal scoreboard',
      url: TOURNAMENT_URL,
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Tournament summary',
      items: [
        { value: '2–1–1', label: 'Match record (W–D–L)' },
        { value: '8 goals', label: 'Scored in 4 matches' },
        { value: 'Runners-up', label: 'Final vs Football Addicts' },
        { value: 'Aug 4–9', label: 'Westerville, OH' },
      ],
    },
    {
      type: 'panel',
      title: 'A week of Little Soccer',
      paragraphs: [
        '**Old Monks** took on the **Little Soccer Internal** tournament across a packed week in **Westerville, Ohio** — four matches from the opening group game through Sunday night\'s championship.',
        'The Monks opened with a win, drew in the group stage, then beat **Desi Tigers** in a semi-final rematch to reach the final. On Sunday evening at **Little Soccer**, they met **Football Addicts** for the title and fell **1–2** after a hard-fought contest.',
        'Not the trophy this time, but a final appearance with **eight goals** across four matches is a run the whole squad can be proud of. Thank you to everyone who followed the scores and cheered on the Monks all week.',
      ],
      chips: ['Old Monks', 'Little Soccer Internal', 'Westerville', 'Aug 2026'],
    },
    {
      type: 'table',
      title: 'Match results',
      intro: 'All four Old Monks fixtures from the published tournament scoreboard.',
      headers: ['Round', 'Opponent', 'Result', 'Date'],
      rows: [
        ['Group', 'Out Of Breath FC', 'Old Monks 3–2', 'Wed, Aug 5 · 6:30 PM'],
        ['Group Stage', 'Desi Tigers', 'Old Monks 2–2', 'Fri, Aug 7 · 6:30 PM'],
        ['Semi-final', 'Desi Tigers', 'Old Monks 2–0', 'Sat, Aug 8 · 7:00 PM'],
        ['Final', 'Football Addicts', 'Old Monks 1–2', 'Sun, Aug 9 · 6:30 PM'],
      ],
    },
    {
      type: 'panel',
      title: 'Group — Old Monks 3–2 Out Of Breath FC',
      paragraphs: [
        'The Monks kicked off tournament week with a comeback-style win at **Westerville**. **Amay** struck twice — in the 10th and 30th minutes — and **Bhupi** sealed the three points with a 40′ finish.',
      ],
      list: [
        "10′ **Amay**",
        '30′ **Amay**',
        '40′ **Bhupi**',
      ],
    },
    {
      type: 'panel',
      title: 'Group Stage — Old Monks 2–2 Desi Tigers',
      paragraphs: [
        'Friday night brought a back-and-forth draw against **Desi Tigers**. **Amay** scored both Monks goals — at 20′ and 30′ — to keep the side in the hunt heading into the knockout rounds.',
      ],
      list: [
        '20′ **Amay**',
        '30′ **Amay**',
      ],
    },
    {
      type: 'panel',
      title: 'Semi-final — Old Monks 2–0 Desi Tigers',
      paragraphs: [
        'Less than 24 hours after the draw, Old Monks faced Desi Tigers again in the semi-final — and this time controlled the tie. **Aslam Abubacker** opened the scoring at 20′ and **Bhupi** added insurance at 40′ for a clean-sheet win and a place in the final.',
      ],
      list: [
        '20′ **Aslam Abubacker**',
        '40′ **Bhupi**',
      ],
    },
    {
      type: 'panel',
      title: 'Final — Old Monks 1–2 Football Addicts',
      paragraphs: [
        'Under the lights on Sunday at **Little Soccer**, **Football Addicts** lifted the championship. The Monks drew first blood when **Bhupi** finished in the 10th minute — set up by **Rony** — but Addicts answered with two goals to take the title.',
        'Heartbreak in the final, but reaching the championship match after a week of group play and a semi-final rematch is a run worth celebrating.',
      ],
      list: ['10′ **Bhupi** (assist Rony)'],
      callout: {
        text: 'Full live scoreboard with minute-by-minute goals',
        url: TOURNAMENT_URL,
      },
    },
    {
      type: 'table',
      title: 'Top scorers & assists',
      intro: 'Tournament totals from the Old Monks roster at Little Soccer Internal.',
      headers: ['Player', 'Goals', 'Assists'],
      rows: [
        ['Amay', '4', '0'],
        ['Bhupi', '3', '0'],
        ['Aslam Abubacker', '1', '0'],
        ['Rony', '0', '1'],
      ],
    },
    {
      type: 'panel',
      title: 'Thank you, Old Monks',
      paragraphs: [
        `To the players, families, and supporters who followed every kick from Westerville — thank you. Share this recap with friends who missed the week, and revisit the [live scoreboard](${TOURNAMENT_URL}) for full match details from Little Soccer Internal.`,
      ],
    },
  ],
};
